/**
 * 系统菜单 系统设置
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
    </el-breadcrumb>


    <!--列表-->
    <el-table
      size="small" :data="listData" :key="color_index"
      highlight-current-row v-loading="loading"
      border element-loading-text="拼命加载中"
      style="width: 100%; margin-top: 20px;"
    >
      <el-table-column label="序号" align="center" type="index" width="60"/>
      <el-table-column prop="code" label="编码"/>
      <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"/>
      <el-table-column prop="value" label="值"/>
      <el-table-column align="center" label="操作" width="220">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="40%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="form" ref="form" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input size="small" v-model="form.name" maxlength="30" disabled ></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input size="small" v-model="form.code" maxlength="30" disabled ></el-input>
        </el-form-item>
        <el-form-item label="值" prop="value">
          <el-input size="small" v-model="form.value" placeholder="请输入值" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import axios from "axios";
import Template from "../../components/template";
import {querySystemSzList, updateSystemSz} from "../../api/userMG";
export default {
  data() {
    return {
      color_index: 0,
      loading: false, //是显示加载
      queryParams: {
      },
      listData: [], //用户数据

      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules 表单验证
      rules: {
        value: [
          { required: true, message: '请输入值', trigger: 'blur' }
        ]
      },
   }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeColor(name) {
      const newStr = name.replace(/“([^“”]*)”/g, '<span style="color: red;">$1</span>');
      return newStr;
    },
    initData() {
      this.getdata()
    },

    // 获取列表
    getdata() {
      // this.identificationRecognize();
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      querySystemSzList().then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      this.title = '修改'
      this.form = JSON.parse(JSON.stringify(row));
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          var params = {
            code: this.form.code,
            value: this.form.value
          }

          // 修改
          updateSystemSz(params).then(res => {
            this.editFormShow = false
            this.loading = false
            if (res.code == 200) {
              this.getdata()
              this.form = {}
              this.$message({
                type: 'success',
                message: '修改成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })

        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.form = {}
        this.editFormShow = false
      }
    },



  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.tree-con {
  width: 250px;
  height: 95%;
  vertical-align: text-top;
  margin-top: 20px;
  display: inline-block;
  border: #544E4F 2px solid;
  border-radius: 8px;
}

</style>





// WEBPACK FOOTER //
// src/views/system/sysSetting.vue